<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('media.edit', { id: vm.$route.params.mediaId })
  }),
  computed: {
    ...mapState('fightersMedia', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('fighters.title'), to: { name: 'fighters.index' } },
      { text: vm.$t('fighters.edit', { id: vm.$route.params.fighterId }), to: { name: 'fighters.edit' } },
      { text: vm.$t('media.title'), to: { name: 'fighters.media.index' } },
      { text: vm.$t('media.edit', { id: vm.$route.params.mediaId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('fightersMedia/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('fightersMedia', ['createItem', 'updateItem'])
  }
}
</script>
